var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSer6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 40v288a8 8 0 0 0 8 8h24v32H40a8 8 0 0 0-16 0v16a8 8 0 0 0 16 0h16v8a8 8 0 0 0 16 0v-24h8a8 8 0 0 0 0-16h-8v-16a8 8 0 0 0 6.946-4.031l32-56a8.028 8.028 0 0 0 .749-6.156c-2.16-7.646-6-30.38 2.075-43.581 3.39-5.541 8.558-8.939 15.8-10.387 20.446-4.09 59.076-3.385 93.344 5.878 29.092 7.863 65.42 24.657 73.277 60.012 13.246 59.611-33.025 120.876-43.923 134.265H40a24.028 24.028 0 0 0-24 24v48a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-48a24.028 24.028 0 0 0-24-24h-40V256h16v40a24 24 0 0 0 48 0V104a24 24 0 0 0-48 0v40h-31.262c-.48-1.135-.969-2.258-1.474-3.353-7.549-16.354-17.9-28.123-31.264-35.462V40a8 8 0 0 0-8-8h-16v-8a8 8 0 0 0-16 0v8h-16a8 8 0 0 0-8 8v57.735c-21.89 3.087-42.283 9.9-63.541 17.008C225.225 125.194 192.926 136 152 136c-70.875 0-71.987-69.077-72-72a8 8 0 0 0-8-8V40h8a8 8 0 0 0 0-16H16a8 8 0 0 0 0 16Zm440 64a8 8 0 0 1 16 0v192a8 8 0 0 1-16 0Zm-16 56v80h-16.162c-.7-33.912-3.754-59.729-9.518-80Zm24 272a8.009 8.009 0 0 1 8 8v40H32v-40a8.009 8.009 0 0 1 8-8ZM336 48h32v50.871A94.562 94.562 0 0 0 344 96c-2.7 0-5.359.09-8 .218ZM40 40h16v16H40Zm0 262.624a24 24 0 1 0 0-45.248V72h24.544a108.184 108.184 0 0 0 10.3 35.578C84.977 127.843 106.588 152 152 152c43.532 0 77.086-11.227 109.536-22.083C289.075 120.7 315.086 112 344 112c27.576 0 45.6 11.233 56.736 35.353C411.15 169.915 416 204.438 416 256v160H272.472a263.461 263.461 0 0 0 20.63-33.317c19.193-37.016 25.662-73.123 18.708-104.418-7.593-34.167-36.89-59.06-84.723-71.988-36.649-9.9-78.378-10.577-100.656-6.122-11.714 2.343-20.576 8.324-26.34 17.778-11.037 18.1-6.7 43.713-4.628 52.881L67.357 320H40ZM40 280a8 8 0 1 1 8 8 8.009 8.009 0 0 1-8-8Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 344a24.027 24.027 0 0 0 24-24v-48a24 24 0 0 0-48 0v48a24.027 24.027 0 0 0 24 24Zm-8-72a8 8 0 0 1 16 0v25.376a23.944 23.944 0 0 0-16 0Zm8 40a8 8 0 1 1-8 8 8.009 8.009 0 0 1 8-8Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer6);
export default __webpack_public_path__ + "static/media/ser-6.b58426571b2cecfc22fe4402bb27626c.svg";
export { ForwardRef as ReactComponent };